import { DOCUMENT } from '@angular/common'
import { Injectable, inject, signal } from '@angular/core'

/**
 * Whether the 2026 theme is on, as a signal outside any injector, so plain functions (column definitions, pill
 * themes) can read it too and recompute when the flag answers late. `NewThemeService.enabled` is the same signal
 */
export const newThemeEnabled = signal(false)

/** Whether the 2026 theme is on, and token values for code that needs numbers (ag-grid heights, for example). */
@Injectable({
  providedIn: 'root',
})
export class NewThemeService {
  /** True while `data-theme="2026"` is on `<html>`. Read it in a `computed` to recompute when the theme switches. */
  public readonly enabled = newThemeEnabled

  protected readonly _document = inject(DOCUMENT)

  /** Value of a `--wm-*` size token in pixels, or undefined when it is not set or not a pixel value (e.g. `auto`). */
  public readPx(token: string): number | undefined {
    const value = parseFloat(
      getComputedStyle(this._document.documentElement).getPropertyValue(
        `--wm-${token}`
      )
    )

    return Number.isNaN(value) ? undefined : value
  }
}
